module.exports = __webpack_public_path__ + "static/media/logo-red.f812ac6b.png";